import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "share",
  "use": "share-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"share\"><path d=\"M128 320s29.412-96 192-96v96l192-128L320 64v96c-128 0-192 79.836-192 160zm224 64H64V192h62.938a204.624 204.624 0 0 1 16.244-17.09c21.982-20.595 48.281-36.326 78.057-46.91H0v320h416V313.688l-64 42.667V384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/share.svg
// module id = CUmr
// module chunks = 1